import { cn } from '@/lib/utils'
import { formatCurrency } from '@/lib/utils/format-business-data'
import { TableCell, TableRow } from '@/components/ui/table'
import { OccupancyBar } from './OccupancyBar'
import { PricingFactorPill } from './PricingFactorPill'
import type { DailyPriceBreakdown } from './price-calculator-types'

const TIER_BORDER: Record<string, string> = {
  low: 'border-l-green-500',
  standard: 'border-l-amber-500',
  peak: 'border-l-red-500',
}

const TIER_TEXT: Record<string, string> = {
  low: 'text-green-600 dark:text-green-400',
  standard: 'text-amber-600 dark:text-amber-400',
  peak: 'text-red-600 dark:text-red-400',
}

interface DailyRateRowProps {
  day: DailyPriceBreakdown
}

export function DailyRateRow({ day }: DailyRateRowProps) {
  return (
    <TableRow className={cn('border-l-2', TIER_BORDER[day.pricingTier])}>
      <TableCell className="py-2 text-xs whitespace-nowrap">
        <span className={cn(day.isWeekend && 'font-semibold')}>
          {day.dayLabel}
        </span>
        {day.isHoliday && (
          <span className="block text-[10px] text-amber-600 dark:text-amber-400">
            {day.holidayName}
          </span>
        )}
      </TableCell>
      <TableCell className="py-2">
        <OccupancyBar pct={day.occupancyPct} />
      </TableCell>
      <TableCell className="py-2">
        <div className="flex flex-wrap gap-1">
          {day.weather !== 'clear' && (
            <PricingFactorPill
              type="weather"
              multiplier={day.weatherMultiplier}
              weather={day.weather}
            />
          )}
          {day.isHoliday && (
            <PricingFactorPill
              type="holiday"
              multiplier={day.holidayMultiplier}
            />
          )}
        </div>
      </TableCell>
      <TableCell className={cn('py-2 text-right font-mono text-sm font-medium', TIER_TEXT[day.pricingTier])}>
        {formatCurrency(day.finalRate)}
      </TableCell>
    </TableRow>
  )
}
